'use client';
import ProductCard from '@/features/HomepageHero/components/ProductCard';
import { useModernLayoutContext } from './Context';

const Slides = () => {
  const { slides, handleSelectSlide, activeSlideIndex } =
    useModernLayoutContext();

  return slides.map((feature, index) => {
    const isActive = index === activeSlideIndex;

    return (
      <ProductCard
        handleSelect={() => handleSelectSlide(index)}
        key={feature.image.image?.data?.attributes?.url}
        feature={feature}
        isActive={isActive}
      />
    );
  });
};

export default Slides;
